import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["status"]
  static values = { updateUrl: String }

  connect() {
    this.saveTimer = null
  }

  save() {
    if (this.saveTimer) clearTimeout(this.saveTimer)
    this.saveTimer = setTimeout(() => this.persist(), 500)
  }

  async persist() {
    const fileInputs = [...this.element.querySelectorAll('input[type="file"]')]
    const hasNewFiles = fileInputs.some((i) => i.files && i.files.length > 0)
    const formData = new FormData(this.element)
    // NOTE: 直接アップロードぶんの hidden field は残り続けるため、 消さないと保存のたびに
    //       同じファイルが再送されて二重に添付される。 FormData に載せた直後に外しておくと
    //       保存が重なっても二重送信にならない ( 失敗したときだけ戻す )。
    const sentUploadedFiles = this.detachUploadedFileFields()
    this.setStatus("保存中…")

    try {
      const response = await fetch(this.updateUrlValue, {
        method: "PATCH",
        body: formData,
        headers: { "X-CSRF-Token": this.csrfToken() }
      })
      if (response.ok) {
        // NOTE: 送信済みファイル input をクリアして次回以降の自動保存で重複送信されないようにする
        fileInputs.forEach((i) => { i.value = "" })
        if (hasNewFiles) {
          window.location.reload()
        } else {
          this.setStatus("保存しました")
        }
      } else {
        this.restoreUploadedFileFields(sentUploadedFiles)
        this.setStatus("保存に失敗しました")
      }
    } catch (_e) {
      this.restoreUploadedFileFields(sentUploadedFiles)
      this.setStatus("保存に失敗しました")
    }
  }

  detachUploadedFileFields() {
    return [...this.element.querySelectorAll('input[name$="[uploaded_files][]"]')].map((input) => {
      const parent = input.parentNode
      input.remove()
      return { input, parent }
    })
  }

  restoreUploadedFileFields(detached) {
    detached.forEach(({ input, parent }) => parent.appendChild(input))
  }

  async submit(event) {
    const submitUrl = event.params.submitUrl
    // NOTE: 待機中の自動保存が後から走ると 同じ添付をもう一度送ってしまうため止める。
    if (this.saveTimer) clearTimeout(this.saveTimer)
    const formData = new FormData(this.element)
    this.detachUploadedFileFields()
    this.setStatus("送信中…")

    try {
      await fetch(this.updateUrlValue, {
        method: "PATCH",
        body: formData,
        headers: { "X-CSRF-Token": this.csrfToken() }
      })

      const submitResponse = await fetch(submitUrl, {
        method: "POST",
        headers: {
          "X-CSRF-Token": this.csrfToken(),
          "Accept": "text/html"
        }
      })

      if (submitResponse.redirected) {
        window.location.href = submitResponse.url
      } else {
        window.location.reload()
      }
    } catch (_e) {
      this.setStatus("送信に失敗しました")
    }
  }

  setStatus(text) {
    if (this.hasStatusTarget) this.statusTarget.textContent = text
  }

  csrfToken() {
    const meta = document.querySelector("meta[name='csrf-token']")
    return meta ? meta.content : ""
  }
}
